import { render } from "./fhirViewer.vue?vue&type=template&id=4e5c2667&scoped=true"
import script from "./fhirViewer.js?vue&type=script&lang=js"
export * from "./fhirViewer.js?vue&type=script&lang=js"

import "./fhirViewer.vue?vue&type=style&index=0&id=4e5c2667&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5c2667"]])

export default __exports__